import { render } from "./DescriptionFormats_Edit.vue?vue&type=template&id=bcbd87e2"
import script from "./DescriptionFormats_Edit.vue?vue&type=script&lang=js"
export * from "./DescriptionFormats_Edit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ET Projeleri\\Erol Teknik Web Uygulamarı\\ETCore_\\etcore-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__